exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".HistoryEvents-HistoryEventsHeader-container{width:100%;margin:auto}.HistoryEvents-HistoryEventsHeader-left{width:60%;float:left}.HistoryEvents-HistoryEventsHeader-right{float:right}.HistoryEvents-HistoryEventsHeader-center{text-align:center;padding:5px}.HistoryEvents-HistoryEventsHeader-blackButton{color:#000;height:50px;overflow:hidden}.HistoryEvents-HistoryEventsHeader-whiteButton{color:#fff;height:50px;overflow:hidden}", ""]);

// exports
exports.locals = {
	"container": "HistoryEvents-HistoryEventsHeader-container",
	"left": "HistoryEvents-HistoryEventsHeader-left",
	"right": "HistoryEvents-HistoryEventsHeader-right",
	"center": "HistoryEvents-HistoryEventsHeader-center",
	"blackButton": "HistoryEvents-HistoryEventsHeader-blackButton",
	"whiteButton": "HistoryEvents-HistoryEventsHeader-whiteButton"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-rules-2!./node_modules/postcss-loader/lib??ref--2-rules-3!./src/components/HistoryEvents/HistoryEventsHeader.css
// module id = 1093
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20